'use client';
import React, { useEffect } from 'react';
import { useSelectedVariant } from '@/components/product/product-context';

export default function FinanceMsg({ isBundle, bundlePrice }) {
  if (isBundle) {
    return <FinanceMsgContent amount={parseInt(bundlePrice, 10) * 100} />;
  }

  return <VariantFinanceMsg />;
}

function VariantFinanceMsg() {
  const { variant } = useSelectedVariant();
  return <FinanceMsgContent amount={parseInt(variant.price, 10) * 100} />;
}

function FinanceMsgContent({ amount }) {
  useEffect(() => {
    if (typeof window['affirm'] !== 'undefined') {
      return;
    }

    const hostname = window.location.hostname;
    const developDomain =
      hostname.indexOf('beta') !== -1 ||
      hostname.indexOf('alpha') !== -1 ||
      hostname.indexOf('localhost') !== -1 ||
      hostname.indexOf('vercel') !== -1;

    const affirmApiKey = developDomain
      ? 'FWUPRAEPEJ8CDZUV'
      : '2LSY5K7PY0C2IZQ7';
    const affirmScript = developDomain
      ? 'https://cdn1-sandbox.affirm.com/js/v2/affirm.js'
      : 'https://cdn1.affirm.com/js/v2/affirm.js';

    const _affirm_config = {
      public_api_key: `${affirmApiKey}`,
      script: `${affirmScript}`,
      locale: 'en_US',
      country_code: 'USA'
    };

    // prettier-ignore
    (function (m, g, n, d, a, e, h, c) { var b = m[n] || {}, k = document.createElement(e), p = document.getElementsByTagName(e)[0], l = function (a, b, c) { return function () { a[b]._.push([c, arguments]); }; }; b[d] = l(b, d, 'set'); var f = b[d]; b[a] = {}; b[a]._ = []; f._ = []; b._ = []; b[a][h] = l(b, a, h); b[c] = function () { b._.push([h, arguments]); }; a = 0; for ( c = 'set add save post open empty reset on off trigger ready setProduct'.split( ' '); a < c.length; a++) f[c[a]] = l(b, d, c[a]); a = 0; for (c = ['get', 'token', 'url', 'items']; a < c.length; a++) f[c[a]] = function () {}; k.async = !0; k.src = g[e]; p.parentNode.insertBefore(k, p); delete g[e]; f(g); m[n] = b; })( window, _affirm_config, 'affirm', 'checkout', 'ui', 'script', 'ready', 'jsReady');
  }, []);

  useEffect(() => {
    if (typeof window['affirm'] !== 'undefined') {
      try {
        window.affirm.ui.ready(function () {
          window.affirm.ui.refresh();
        });
      } catch (err) {
        console.error('Affirm could not refresh: ', err);
      }
    }
  }, [amount]);

  return (
    <>
      {amount && (
        <div
          id="finance-msg"
          className="affirm-as-low-as flex-wrap text-white"
          data-page-type="product"
          data-affirm-color="white"
          data-amount={amount}
          aria-label="See if you qualify (opens in modal)"
        ></div>
      )}
    </>
  );
}
